// Force the app to reload fresh from the server: clear every Cache Storage entry
// and unregister any service workers (which can keep serving a stale app shell,
// especially in an installed PWA), then reload. Exposed as a manual "refresh from
// server" action because the installed PWA has no browser reload/hard-refresh UI.
export async function refreshFromServer({ reload } = {}) {
  const doReload = reload || (() => window.location.reload())

  try {
    if (typeof window !== 'undefined' && 'caches' in window) {
      const keys = await window.caches.keys()
      await Promise.all(keys.map(key => window.caches.delete(key)))
    }
  } catch (error) {
    console.warn('Failed to clear caches during refresh:', error)
  }

  try {
    if (typeof navigator !== 'undefined' && navigator.serviceWorker) {
      const registrations = await navigator.serviceWorker.getRegistrations()
      await Promise.all(registrations.map(registration => registration.unregister()))
    }
  } catch (error) {
    console.warn('Failed to unregister service workers during refresh:', error)
  }

  doReload()
}
